import styled from 'styled-components'

export const ListWrapper = styled.div`
  contain: strict;
  overflow-anchor: none;
  will-change: transform;
`

export const ListOuter = styled.div`
  position: relative;
  width: 100%;
`

export const ListInner = styled.div`
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`
